// import React, { useState } from "react";
// import { MdClose } from "react-icons/md";
// import CustomButton from "./CustomButton";
// import InputField from "./InputField";
// import { useForm, FieldValues, SubmitHandler } from "react-hook-form";

// interface ModalProps {
//   modalOpen?: boolean;
//   setModalOpen?: any;
//   setFile?: any;
// }

// interface FormData {
//   url?: string;
//   file?: FileList; // Use FileList for file input
// }

// const FileUploadModal: React.FC<ModalProps> = ({
//   modalOpen,
//   setModalOpen,
//   setFile,
// }) => {
//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//     setError,
//     clearErrors,
//     getValues,
//   } = useForm<FormData>();
//   const [fileType, setFileType] = useState<boolean>(false);

//   const handleSubmitData: SubmitHandler<FormData> = (data) => {
//     if (!data.url && !data.file) {
//       setError("url", {
//         type: "manual",
//         message: "Either URL or File is required",
//       });
//       setError("file", {
//         type: "manual",
//         message: "Either URL or File is required",
//       });
//       return;
//     }

//     console.log(data);
//     clearErrors(["url", "file"]);
//   };

//   return (
//     <>
//       {modalOpen && (
//         <div className="h-screen flex justify-center items-center overflow-hidden p-8 bg-black/30 fixed top-0 start-0 w-full inset-0 z-50 transition-opacity backdrop-blur-lg">
//           <div className="bg-white rounded-xl w-1/2 mx-auto p-4 shadow-lg transform transition-all duration-300 ease-in-out">
//             <div className="flex justify-between items-center">
//               <p className="text-center font-semibold text-lg">File Type</p>
//               <div
//                 role="button"
//                 onClick={() => setModalOpen(false)}
//                 className="w-10 h-10 text-white bg-darkCyan flex justify-center items-center rounded-xl"
//               >
//                 <MdClose size={25} />
//               </div>
//             </div>

//             <div className="flex gap-3 justify-center mt-4">
//               <CustomButton
//                 handleClick={() => {
//                   setFileType(false);
//                   clearErrors(["url", "file"]);
//                 }}
//                 btntext="URL"
//                 bg={!fileType ? "bg-darkCyan" : "bg-gray-400"}
//               />
//               <CustomButton
//                 handleClick={() => {
//                   setFileType(true);
//                   clearErrors(["url", "file"]);
//                 }}
//                 btntext="Local Device"
//                 bg={fileType ? "bg-darkCyan" : "bg-gray-400"}
//               />
//             </div>
//             <form
//               onSubmit={(e) => {
//                 e.preventDefault();
//                 handleSubmit(handleSubmitData)(e);
//               }}
//             >
//               {!fileType ? (
//                 <InputField
//                   label="URL"
//                   placeholder="Enter url"
//                   type="text"
//                   name="url"
//                   register={register("url", {
//                     validate: (value) => {
//                       if (!value && !getValues("file")) {
//                         return "Either URL or File is required";
//                       }
//                       return true;
//                     },
//                   })}
//                   error={errors.url?.message}
//                 />
//               ) : (
//                 <InputField
//                   label="Upload Video"
//                   type="file"
//                   register={register("file", {
//                     validate: (value) => {
//                       // Check if value is defined before accessing its properties
//                       if (value && value.length === 0 && !getValues("url")) {
//                         return "Either URL or File is required";
//                       }
//                       return true;
//                     },
//                   })}
//                   error={errors.file?.message}
//                 />
//               )}
//               <div className="mt-4">
//                 <CustomButton
//                   type="submit"
//                   btntext="Submit"
//                   bg={"bg-darkCyan"}
//                   addclass="w-full"
//                 />
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default FileUploadModal;

import React, { useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { MdClose } from "react-icons/md";
import ReactPlayer from "react-player";
import CustomButton from "./CustomButton";
import InputField from "./InputField";

interface ModalProps {
  modalOpen?: boolean;
  setModalOpen?: any;
  onFileUpload: (data: { url?: string; file?: File | null }) => void; // Callback prop to send data back to parent
}

interface FormData {
  url?: string;
  file?: FileList; // Use FileList for file input
}

const FileUploadModal: React.FC<ModalProps> = ({
  modalOpen,
  setModalOpen,
  onFileUpload,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    clearErrors,
    getValues,
    reset,
  } = useForm<FormData>();
  const [fileType, setFileType] = useState<boolean>(false); // false for URL, true for File
  const [loading, setLoading] = useState(false);

  const checkVideoPlayable = async (url: string) => {
    if (ReactPlayer.canPlay(url)) {
      clearErrors("url"); // ✅ Video is playable
      return true;
    }
    try {
      setLoading(true);

      const response = await fetch(url, { method: "HEAD" });

      if (
        response.ok &&
        response.headers.get("content-type")?.includes("video")
      ) {
        clearErrors("url"); // ✅ Valid video, clear errors
        return true;
      } else {
        setError("url", {
          type: "manual",
          message:
            "This video link cannot be played. Please enter a valid video URL.",
        });
        return false;
      }
    } catch (error) {
      setError("url", {
        type: "manual",
        message: "Could not verify video. Please enter a correct video link.",
      });
      return false;
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitData: SubmitHandler<FormData> = async (data) => {
    const isValid = await checkVideoPlayable(data.url || "");
    if (isValid || data.file) {
      if (!data.url && (!data.file || data.file.length === 0)) {
        setError("url", {
          type: "manual",
          message: "Either URL or File is required",
        });
        setError("file", {
          type: "manual",
          message: "Either URL or File is required",
        });
        return;
      }

      // Pass data to the parent component via callback
      if (data.file && data.file.length > 0) {
        onFileUpload({ file: data.file[0] });
      } else if (data.url) {
        onFileUpload({ url: data.url });
      }

      clearErrors(["url", "file"]);
      setModalOpen(false); // Close the modal after successful submission
      reset();
    }
  };

  return (
    <>
      {modalOpen && (
        <div className="h-screen flex justify-center items-center overflow-hidden p-8 bg-black/30 fixed top-0 start-0 w-full inset-0 z-50 transition-opacity backdrop-blur-lg">
          <div className="bg-white rounded-xl w-1/2 mx-auto p-4 shadow-lg transform transition-all duration-300 ease-in-out">
            <div className="flex justify-between items-center">
              <p className="text-center font-semibold text-lg">File Type</p>
              <div
                role="button"
                onClick={() => setModalOpen(false)}
                className="w-10 h-10 text-white bg-darkCyan flex justify-center items-center rounded-xl"
              >
                <MdClose size={25} />
              </div>
            </div>

            <div className="flex gap-3 justify-center mt-4">
              <CustomButton
                handleClick={() => {
                  setFileType(false);
                  clearErrors(["url", "file"]);
                }}
                btntext="URL"
                bg={!fileType ? "bg-darkCyan" : "bg-gray-400"}
              />
              <CustomButton
                handleClick={() => {
                  setFileType(true);
                  clearErrors(["url", "file"]);
                }}
                btntext="Local Device"
                bg={fileType ? "bg-darkCyan" : "bg-gray-400"}
              />
            </div>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit(handleSubmitData)(e);
              }}
            >
              {!fileType ? (
                <InputField
                  label="URL"
                  placeholder="Enter url"
                  type="text"
                  // name="url"
                  register={register("url", {
                    validate: (value) => {
                      if (!value && !getValues("file")) {
                        return "Video URL is required";
                      }

                      // ✅ Allow YouTube, Vimeo, Dailymotion, and Facebook Watch links
                      const videoPlatformRegex =
                        /^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=|shorts\/)|youtu\.be\/|vimeo\.com\/|dailymotion\.com\/video\/|facebook\.com\/watch\/|twitch\.tv\/videos\/)/;

                      // ✅ Allow AWS S3 or other direct video file URLs (.mp4, .mov, etc.)
                      const videoFileRegex =
                        /(https?:\/\/.*\.(mp4|avi|mov|mkv|flv|wmv))(\?.*|\d*)?$/i;

                      // ✅ AWS S3 specific validation (checking if it's an S3 video)
                      const awsS3Regex =
                        /^https:\/\/.*s3\..*\.amazonaws\.com\/.*\.(mp4|avi|mov|mkv|flv|wmv)(\?.*|\d*)?$/i;

                      // ✅ Final Check: Match either a known video platform, direct video file, or AWS S3
                      if (
                        !videoPlatformRegex.test(value || "") &&
                        !videoFileRegex.test(value || "") &&
                        !awsS3Regex.test(value || "")
                      ) {
                        return "Invalid video URL. Please enter a valid YouTube, Vimeo, or direct video file link.";
                      }

                      return true;
                    },
                  })}
                  error={errors.url?.message}
                />
              ) : (
                <InputField
                  label="Upload Video"
                  type="file"
                  register={register("file", {
                    validate: (value) => {
                      if (value && value.length === 0 && !getValues("url")) {
                        return "Either URL or File is required";
                      }
                      return true;
                    },
                  })}
                  accpect={"video/mp4"}
                  error={errors.file?.message}
                />
              )}
              <div className="mt-4">
                <CustomButton
                  isLoading={loading}
                  type="submit"
                  btntext="Submit"
                  bg={"bg-darkCyan"}
                  addclass="w-full"
                />
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default React.memo(FileUploadModal);
